export default (state = {}, action) => {
    switch (action.type) {
        case "LOGIN":
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};
